module.exports = __webpack_public_path__ + "static/assets/5a996e7d6a0b67d20e8a7f25d3c5af22.svg";